import React, { useState } from "react";
import { Box, Button, Popover, TextField, Typography } from "@mui/material";

const LinkComponent = ({ editor, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [linkUrl, setLinkUrl] = useState("");

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);

    const previousUrl = editor.getAttributes("link").href || "";

    setLinkUrl(previousUrl);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLinkUrl("");
  };

  const handleSave = () => {
    if (!linkUrl.trim()) {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
    } else {
      let url = linkUrl.trim();

      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = `https://${url}`;
      }

      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({
          href: url,
        })
        .run();
    }

    handleClose();
  };

  return (
    <>
      <Box
        component="span"
        onClick={handleOpen}
        sx={{
          display: "inline-flex",
          cursor: "pointer",
        }}
      >
        {children}
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            width: 320,
            p: 2,
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            Insert Link
          </Typography>

          <TextField
            fullWidth
            size="small"
            autoFocus
            placeholder="https://example.com"
            value={linkUrl}
            onChange={(e) => setLinkUrl(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSave();
              }
            }}
          />

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>

            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default React.memo(LinkComponent);
